import React, { useEffect } from 'react';
import styles from './ConfirmationModal.module.css';

interface ConfirmationModalProps {
  isOpen: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ 
  isOpen, 
  message, 
  onConfirm, 
  onCancel 
}) => {
  // 按ESC键关闭模态框
  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isOpen) {
        onCancel();
      }
    };

    window.addEventListener('keydown', handleEscKey);

    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen, onCancel]);

  // 点击模态框外部关闭
  const handleOutsideClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  // 如果不是打开状态，不渲染任何内容
  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={handleOutsideClick}>
      <div className={styles.modalContainer}>
        <div className={styles.modal}>
          <div className={styles.warningIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
              <path fill="none" d="M0 0h24v24H0z"/>
              <path fill="#f39c12" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z"/>
            </svg>
          </div>
          <div className={styles.content}>
            <p>{message}</p>
          </div>
          <div className={styles.actions}>
            <button 
              className={styles.cancelButton} 
              onClick={onCancel}
            >
              取消
            </button>
            <button 
              className={styles.confirmButton} 
              onClick={onConfirm}
              autoFocus
            >
              确认
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;